<template>
  <div class="privacy-container">
    <div class="privacy-header">
      <div class="header-title">隐私政策</div>
    </div>
    <div class="privacy-content">
        <h2>{{name}}隐私政策</h2>
                <p>{{companyName}}（下称"我们"）深知个人信息对您的重要性，并致力于保护您的隐私。本《隐私政策》旨在说明"{{name}}"（下称"本产品"）如何收集、使用、存储、共享和保护您的信息，并告知您享有的权利。</p>
                
                <h3>一、 我们收集的信息</h3>
                <p>1.1 <strong>您主动提供的信息</strong></p>
                <ul>
                    <li><strong>账户信息</strong>：当您注册账户时，我们会收集您的姓名、电子邮箱地址、手机号码等。</li>
                    <li><strong>问卷内容</strong>：您在使用本产品创建问卷时，输入的所有内容，包括问题、选项、封面等。</li>
                    <li><strong>答题人信息</strong>：
                        <ul>
                            <li>当您设置"收集答题用户信息"时，我们会根据您的设置收集答题人的信息，如姓名、邮箱、手机号、公司、职位等。</li>
                            <li>答题人在回答问卷时提交的所有信息，包括选择题答案、填空题文本、评分、文件上传等。</li>
                        </ul>
                    </li>
                </ul>
                
                <p>1.2 <strong>我们自动收集的信息</strong></p>
                <ul>
                    <li><strong>日志信息</strong>：当您使用我们的服务时，我们会自动收集相关信息并存储为服务器日志，包括IP地址、浏览器类型、访问日期和时间、操作记录等。</li>
                    <li><strong>设备信息</strong>：我们可能会收集您设备的型号、操作系统版本、唯一设备标识符等信息。</li>
                    <li><strong>Cookies和类似技术</strong>：我们使用Cookies来保持您的登录状态、识别您的偏好、分析产品使用情况以优化我们的服务。您可以在浏览器设置中管理或禁用Cookies。</li>
                </ul>
                
                <h3>二、 我们如何使用您的信息</h3>
                <p>我们出于以下目的使用收集到的信息：</p>
                <ul>
                    <li><strong>提供和维护核心服务</strong>：创建和管理您的账户、处理问卷的创建、发布、回收和统计分析。</li>
                    <li><strong>与您沟通</strong>：向您发送服务通知、技术更新、安全警报和管理员消息。</li>
                    <li><strong>改善服务</strong>：通过分析聚合数据和使用趋势，来优化我们的产品功能和用户体验。</li>
                    <li><strong>安全保障</strong>：用于身份验证、欺诈监测和安全防范。</li>
                    <li><strong>遵守法律</strong>：遵守适用的法律法规和司法程序。</li>
                </ul>
                
                <h3>三、 我们如何共享、转让、公开披露您的信息</h3>
                <p>我们<strong>不会</strong>将您的个人信息出售给第三方。我们仅在以下情况下共享您的信息：</p>
                <ul>
                    <li><strong>获得您的明确同意</strong>。</li>
                    <li><strong>向我们的关联公司或服务提供商共享</strong>：例如，我们使用云服务器提供商来存储数据，使用短信或邮件服务商来发送验证码。这些第三方仅在为我们提供服务所必需的范围内接触您的信息，并受严格的合同义务约束。</li>
                    <li><strong>为遵守法律</strong>：如果我们确信为了遵守法律、法规、法律程序或政府强制要求而必须披露您的信息。</li>
                    <li><strong>保护权利和财产</strong>：为执行我们的服务条款或保护我们、我们的用户或公众的权利、财产和安全。</li>
                </ul>
                
                <h3>四、 数据安全</h3>
                <p>我们采用符合行业标准的安全技术和管理措施（如加密传输、访问控制）来保护您的信息免遭丢失、滥用、篡改和破坏。然而，请注意，任何互联网传输方法或电子存储方法都不是100%安全的，我们无法保证信息的绝对安全。</p>
                
                <h3>五、 您的权利</h3>
                <p>您对您的个人信息享有以下权利：</p>
                <ul>
                    <li><strong>访问和更正</strong>：您可以登录您的账户，访问和修改您的个人资料信息。</li>
                    <li><strong>删除</strong>：您可以联系我们，要求删除您的账户及个人数据。但请注意，为遵守法律或解决争议，我们可能需要保留某些信息。</li>
                    <li><strong>撤回同意</strong>：您可以通过调整问卷设置或联系我们，撤回对某些信息处理的同意。但这不影响撤回前基于同意的数据处理活动的合法性。</li>
                    <li><strong>注销账户</strong>：您可以在产品设置中申请注销账户。账户注销后，我们将停止为您提供产品服务，并根据适用法律删除您的个人信息或进行匿名化处理。</li>
                </ul>
                
                <div class="highlight">
                    <h3>六、 关于问卷创建者与答题人的特别说明</h3>
                    <p><strong>问卷创建者</strong>：您在使用本产品收集他人（答题人）信息时，您是相关个人信息的"控制者"。您有独立的、完全的责任：</p>
                    <ul>
                        <li>确保您已获得答题人的明确授权和同意。</li>
                        <li>向答题人清晰地告知您收集信息的目的、处理方式以及隐私政策。</li>
                        <li>遵守所有适用于数据控制者的法律法规。</li>
                    </ul>
                    <p><strong>答题人</strong>：如果您是问卷的答题人，您的信息处理主要由问卷的创建者决定。如果您对问卷内容或您的数据有疑问，请直接联系该问卷的创建者。同时，您也可以根据本政策行使您的权利，我们会协助您联系创建者或根据法律要求直接处理。</p>
                </div>
                
                <h3>七、 本政策的更新</h3>
                <p>我们可能会适时更新本政策。更新后，我们会在本页面发布新版政策，并通过显著方式（如网站公告、邮件）通知您。请您定期查阅。</p>
    </div>
  </div>
</template>

<script>
import config from "@/utils/config";
export default {
  name: 'PrivacyPolicyPage',
  data() {
    return {
      // 页面数据
      name: config.name,
      companyName: config.companyName,
    }
  },
  mounted() {
    // 页面加载时的初始化操作
  }
}
</script>

<style scoped>
.privacy-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  min-height: 80vh;
}

.privacy-header {
  margin-bottom: 30px;
  text-align: center;
}

.header-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  padding: 20px 0;
  border-bottom: 1px solid #e8e8e8;
}

.privacy-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.privacy-content h2 {
  font-size: 22px;
  margin-bottom: 20px;
  color: #333;
}

.privacy-content h3 {
  font-size: 18px;
  margin-top: 30px;
  margin-bottom: 15px;
  color: #333;
}

.privacy-content p {
  font-size: 14px;
  line-height: 2;
  color: #666;
  margin-bottom: 10px;
}

.privacy-content p:first-child {
  margin-bottom: 10px;
}



@media (max-width: 768px) {
  .privacy-container {
    padding: 10px;
  }
  
  .privacy-content {
    padding: 20px;
  }
  
  .privacy-content h2 {
    font-size: 20px;
  }
  
  .privacy-content h3 {
    font-size: 16px;
  }
  
  .privacy-content p {
    font-size: 13px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Agreement/privacy.vue